angular.module('jv.Common.i18n', [])

.config(['$provide', function($provide) {
	if (typeof i18n === 'undefined') {
		throw new Error('No global variable "i18n" found! Please provide it.');
	}

	$provide.value('i18n', i18n);
}])

.run(['$rootScope', 'i18n', function($rootScope, i18n) {
	$rootScope.i18n = i18n;
}]);
